<template>
  <div class="pay-toast" :class="{ 'top': showOnTop, 'bottom': !showOnTop, 'heightFoot': !showOnTop && isHeightFoot }">
    <div class="countdown">
      待支付 低价倒计时
      <span class="time-unit minutes">{{ formatTime(remainingTime).minutes }}:</span>
      <span class="time-unit seconds">{{ formatTime(remainingTime).seconds }}:</span>
      <span class="time-unit milliseconds">{{ formatTime(remainingTime).milliseconds }}</span>
    </div>
    <div class="content">
      <p v-if="!isRole3EntertainmentPayment">开通会员享全曲库歌曲 高质歌曲 发礼物 发特效等特权</p>
    </div>
    <!-- role5 用户的按钮布局 -->
    <div v-if="isRole5User" class="buttons buttons-role5">
      <button class="btn-pay btn-pay-center" @click="handlePay">立即支付 唱好歌</button>
    </div>
    <!-- role3 娱乐支付用户的按钮布局 -->
    <div v-else-if="isRole3EntertainmentPayment" class="buttons">
      <button class="btn-cancel" @click="handleCancel">放弃特权</button>
      <button class="btn-pay" @click="handlePay">立即支付 霸气上屏</button>
    </div>
    <!-- 其他用户的按钮布局 -->
    <div v-else class="buttons">
      <button class="btn-cancel" @click="handleCancel">放弃特权</button>
      <button class="btn-pay" @click="handlePay">立即支付 唱好歌</button>
    </div>
    <!-- role5 用户的图片关闭按钮 -->
    <img
      v-if="isRole5User"
      class="close-btn-role5"
      src="https://qncweb.ktvsky.com/20250701/vadd/62b65ab0418e4bbe82ad7c15f5ecb815.png"
      @click="handleClose"
      alt="关闭"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { apis, utils } from '@/libs/interfaces';

export default {
  data() {
    return {
      remainingTime: 5 * 60 * 1000, // 5分钟倒计时
      showOnTop: true,
      timer: null,
      positionTimer: null
    }
  },
  computed: {
    ...mapState({
      openid: (state) => state.openid,
      unionid: (state) => state.unionid,
      pendingPayment: (state) => state.pendingPayment,
      appHistory: (state) => state.appHistory,
      role: (state) => state.role,
      photo_interact_path_new: (state) => state.photo_interact_path_new
    }),
    isHeightFoot() {
      return this.appHistory < 2 && /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
    },
    isRole5User() {
      return this.role === 'role5'
    },
    // 判断是否为娱乐支付类型
    isEntertainmentPayment() {
      return this.pendingPayment && this.pendingPayment.type === 'entertainment'
    },
    // 判断是否为role3用户的娱乐支付
    isRole3EntertainmentPayment() {
      return this.role === 'role3' && this.isEntertainmentPayment
    },
  },
  watch: {
    // 监听待支付信息变化，重置倒计时和位置
    pendingPayment: {
      handler(newVal, oldVal) {
        // 当有新的待支付信息时，重置倒计时和位置
        if (newVal && newVal !== oldVal) {
          this.resetCountdownAndPosition()
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.startCountdown()
    this.startPositionTimer()
  },
  methods: {
    // 重置倒计时和位置的方法
    resetCountdownAndPosition() {
      // 清除现有的定时器
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (this.positionTimer) {
        clearTimeout(this.positionTimer)
      }

      // 重置倒计时为5分钟
      this.remainingTime = 5 * 60 * 1000

      // 重置位置为顶部
      this.showOnTop = true

      // 重新启动倒计时和位置定时器
      this.startCountdown()
      this.startPositionTimer()
    },
    startCountdown() {
      this.timer = setInterval(() => {
        this.remainingTime -= 10
        if (this.remainingTime <= 0) {
          this.handleClose()
        }
      }, 10)
    },
    startPositionTimer() {
      // role5 用户不切换到底部，始终保持在上方
      if (this.isRole5User) {
        return
      }

      this.positionTimer = setTimeout(() => {
        this.showOnTop = false
      }, 10000) // 10秒后切换到底部
    },
    formatTime(time) {
      const minutes = Math.floor(time / 60000).toString().padStart(2, '0')
      const seconds = Math.floor((time % 60000) / 1000).toString().padStart(2, '0')
      const milliseconds = Math.floor((time % 1000) / 10).toString().padStart(2, '0')
      return { minutes, seconds, milliseconds }
    },
    handleCancel() {
      this.handleClose()
    },
    handlePay() {
      console.log('pendingPayment', this.pendingPayment);

      if (this.isEntertainmentPayment) {
        // 娱乐支付重新发起
        this.$store.dispatch('wxpay', {
          params: {
            unionid: this.unionid,
            openid: this.openid,
            pkg_id: 1001,
            entrance: 'payPendingToast_SP',
          },
          wxUrl: apis.privilegeWxpay,
          elseData: {
            callback: () => {
              setTimeout(() => {
                this.navigateToPhotoPage();
              }, 1000);
            },
          }
        });
      } else {
        // VIP支付重新发起
        utils.util.buyVipPlus({
          ...this.pendingPayment,
          $this: this,
          pay_enter: 'payPendingToast',
        });
      }
    },
    // 导航到照片页面，如果当前已在该页面则刷新
    navigateToPhotoPage() {
      const targetPath = this.photo_interact_path_new;
      const currentPath = this.$route.path;

      if (currentPath === targetPath) {
        // 如果当前页面就是目标页面，刷新页面
        window.location.reload();
      } else {
        // 否则正常跳转
        this.$router.push(targetPath);
      }
    },
    handleClose() {
      this.$sendLog({
        event_type: 'show',
        event_name: '待支付-放弃特权-欢乐歌房引导展示',
      })
      this.$nextTick(() => {
        utils.util.showHappyRoomGuidePopup({
          action: '待支付-放弃特权-欢乐歌房引导点击',
          $this: this,
        })
      })
      clearInterval(this.timer)
      clearTimeout(this.positionTimer)
      this.$store.commit('SET_SHOW_PAY_TOAST', false)
      // 清除待支付信息
      this.$store.commit('SET_PENDING_PAYMENT', null)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearTimeout(this.positionTimer)
  }
}
</script>

<style lang="scss" scoped>
.pay-toast {
  position: fixed;
  left: 10px;
  right: 0;
  width: 730px;
  border-radius: 20px;
  padding: 40px 30px 30px 40px;
  background-color: #D8FFDF;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1000;
  transition: all 0.3s ease;
}

.pay-toast.top {
  top: 10px;
}

.pay-toast.bottom {
  bottom: 140px; /* 留出底部菜单栏的空间 */
}
.heightFoot {
  bottom: 200px;
}
.countdown {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 10px;
  .time-unit {
    display: inline-block;
    color: #FF334E;
    width: 70px;
  }
}

.content {
  margin-bottom: 15px;
}
.buttons {
  display: flex;
  justify-content: flex-start;
  align-items: self-end;
  gap: 20px;
}

.btn-cancel, .btn-pay {
  font-size: 32px;
  font-weight: bold;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border-radius: 40px;
}

.btn-cancel {
  width: 140px;
  background: #E6E6E6;
  color: #666666;
  height: 50px;
  line-height: 50px;
  font-size: 24px;
  font-weight: normal;
}

.btn-pay {
  width: 440px;
  background: linear-gradient(145deg, #FFDF00, #FFB700) !important; /* 金色渐变 */
  color: #FF0000 !important; /* 红色字体 */
  font-weight: bold !important;
  margin-left: 20px; /* 向左移动 */
}

/* role5 用户特殊样式 */
.buttons-role5 {
  justify-content: center !important;
  margin-top: 20px;
}

.btn-pay-center {
  width: 440px !important;
}

.close-btn-role5 {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 10;
}
</style>
